import { render, staticRenderFns } from "./LpMultipleColorInput.vue?vue&type=template&id=552e6a54&scoped=true"
import script from "./LpMultipleColorInput.vue?vue&type=script&lang=js"
export * from "./LpMultipleColorInput.vue?vue&type=script&lang=js"
import style0 from "./LpMultipleColorInput.vue?vue&type=style&index=0&id=552e6a54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e6a54",
  null
  
)

export default component.exports